import IntlMessageFormat from 'intl-messageformat';

interface Translations {
  locale: string;
  translations: any; // Use any to support dynamic nested structure
}

class I18n {
  private static instance: I18n;
  private translations: Translations | null = null;

  private constructor() {
    this.loadTranslations();
  }

  public static getInstance(): I18n {
    if (!I18n.instance) {
      I18n.instance = new I18n();
    }
    return I18n.instance;
  }

  private loadTranslations(): void {
    const i18nData = document.getElementById('i18n-data');
    if (i18nData?.textContent) {
      try {
        this.translations = JSON.parse(i18nData.textContent);
      } catch (error) {
        console.error('Failed to parse i18n data:', error);
      }
    }
  }

  public t(key: string, params?: Record<string, any>): string {
    if (!this.translations) return key;

    const keys = key.split('.');
    let value: any = this.translations.translations;

    for (const k of keys) {
      value = value?.[k];
      if (value === undefined) return key;
    }

    if (!value) return key;

    if (params) {
      const formatter = new IntlMessageFormat(value, this.translations.locale);
      return formatter.format(params) as string;
    }

    return value;
  }

  public getLocale(): string {
    return this.translations?.locale || 'en-GB';
  }
}

export const i18n = I18n.getInstance();
